var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.path ? _c("code", [_vm._v(_vm._s(_setup.path))]) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }